import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puedo conducir y trabajar durante SAINT®?",
    answer:
      "Como SAINT® no usa anestesia ni sedación, el paciente puede generalmente conducir al y desde la clínica cada día. Sin embargo, durante la semana de tratamiento debe estar en la clínica la mayor parte de cada día, por lo que la mayoría de los pacientes no trabajan esa semana.",
  },
];

export const esCanDriveAndWork = makeEsArticle({
  slug: "can-i-drive-and-work-during-saint-tms",
  title: "¿Puedo conducir y trabajar durante SAINT®?",
  description:
    "Como SAINT® no usa anestesia, el paciente puede generalmente conducir cada día. Sin embargo, la semana de tratamiento requiere estar en la clínica la mayor parte del día.",
  h1: "¿Puedo conducir y trabajar durante SAINT®?",
  breadcrumbLabel: "Conducir y trabajar en SAINT®",
  shortAnswer:
    "Como SAINT® no usa anestesia ni sedación, el paciente puede generalmente conducir al y desde la clínica cada día. Sin embargo, durante la semana de tratamiento debe estar en la clínica la mayor parte de cada día (unas 10 sesiones con descansos de aproximadamente 50 minutos), por lo que la mayoría de los pacientes no trabajan esa semana. Los plazos de reincorporación laboral dependen de cada persona y se analizan en la consulta.",
  keyTakeaways: [
    "SAINT® no usa anestesia ni sedación.",
    "El paciente puede generalmente conducir cada día.",
    "La semana de tratamiento requiere estar en la clínica la mayor parte del día.",
    "La mayoría de los pacientes no trabajan esa semana.",
    "La reincorporación laboral se analiza en la consulta.",
  ],
  sections: [
    {
      heading: "Conducir",
      paragraphs: [
        "Como SAINT® no usa anestesia ni sedación, el paciente permanece despierto y alerta y puede generalmente conducir al y desde la clínica cada día.",
      ],
    },
    {
      heading: "Trabajo",
      paragraphs: [
        "Cada día de tratamiento incluye aproximadamente 10 sesiones con descansos de aproximadamente 50 minutos entre ellas, por lo que el paciente debe estar en la clínica la mayor parte del día. La mayoría de los pacientes programan tiempo libre del trabajo durante la semana de SAINT®.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
